export const getUnitsInfo = async (listingCode: string, selectedUnitCode: string, nuxtApp: any) => {
  try {
    const { $imsDataService } = nuxtApp

    const unitPaymentPlan = await $imsDataService.getUnit(listingCode, selectedUnitCode)
    if (!unitPaymentPlan) throw new Error('No payment plan found')

    return {
      quotationPlan: unitPaymentPlan
    }
  } catch (error: any) {
    throw createError({
      statusCode: 404,
      statusMessage: 'No payment plan found',
      fatal: true
    })
  }
}
